/* eslint-disable react/jsx-props-no-spreading */
import React, { Suspense, lazy } from 'react';

export const HowItWorksAccordionSuspense = (props) => {
  if (typeof window === 'undefined') return <div />;

  const HowItWorksAccordion = lazy(() => import('./index'));

  return (
    <Suspense fallback={<div />}>
      <HowItWorksAccordion {...props} />
    </Suspense>
  );
};
